<template>
	<div style="padding: 20px; background-color: #F7F7F7;">
		<span v-if="campo.titulo" class="mb-4 d-block">
			<b>{{ campo.titulo }}</b>
		</span>
		<!-- Se elimina porque no tiene que aparecer en las nuevas prestaciones PETECATA Y POECATA -->
		<!-- <span v-if="[20, 22, 31, 32].includes(campo.id)" class="mb-4 d-block">
			Puede <a class="btn-link" @click="getFormulario()" target="_blank">descargar un nuevo formulario</a> o
			puede <a class="btn-link" @click="getDocumentoIncompleto()">descargar la documentación presentada</a> para
			completarla.
		</span> -->
		<!-- Se elimina porque no tiene que aparecer en las nuevas prestaciones PETECATA Y POECATA -->
		<!-- <div v-if="[13].includes(campo.id) && campo.combinacionDocs && campo.combinacionDocs.length > 0"
			class="mb-4 d-block && campo.combinacioDocs ">
			<span v-if="checkIdCombinaciones(campo.combinacionDocs)">
				<a class="btn-link" @click="getFormulario()" target="_blank">Descargar</a> resumen de facturación
				mensual
			</span>
		</div> -->

		<div>
			<v-select outlined v-model="idCombinacion" :items="campo.combinacionDocs" item-text="combinacionNombre"
				item-value="id" menu-props="bottom, offsetY" label="Selecciona una opción" class="no-messages"
				:disabled="disableCombinacionDocs" @change="getCombinacionDocumentos(campo.combinacionDocs)" />
		</div>
		<!-- Documentos: {{ documentos }} -->
		<ListaDocumentos :idCampo="campo.id" :idCombinacion="idCombinacion" :textoAyuda="textoAyuda"
			:documentos="documentos" @documento-changed="documentoChanged($event)" />
		<ModalComentariosByCampo :campo="campo" />
	</div>
</template>

<script>
import api from '@Base/services/documentosService';
import ListaDocumentos from './ListaDocumentos.vue';
import ModalComentariosByCampo from './ModalComentariosByCampo.vue';

export default {
	name: 'Campo',
	components: {
		ListaDocumentos, ModalComentariosByCampo
	},
	props: ['campo'],
	data() {
		return {
			idCombinacion: null,
			documentos: [],
			textoAyuda: null,
			disableCombinacionDocs: false,
			getCombinacionDocumentos(combinaciones) {
				var combinacion = combinaciones.find(x => x.id == this.idCombinacion);
				if (!combinacion) {
					return;
				}

				this.textoAyuda = combinacion.textoAyuda;
				this.documentos = combinacion.documentos.sort((a, b) => a.orden - b.orden);

				var documentosConArchivo = this.documentos.filter(x => x.idSolDocumento && x.nombreArchivo).length;
				this.disableCombinacionDocs = documentosConArchivo > 0;

				this.$emit('combinacion-changed', { idCampo: this.campo.id, idCombinacion: this.idCombinacion });
			},
			documentoChanged(documento) {
				var doc = this.documentos.find(x => x.idSubsaTipoDocumento == documento.idSubsaTipoDocumento);

				doc.idSolDocumento = documento.idSolDocumento;
				doc.nombreArchivo = documento.nombreArchivo;

				var documentosConArchivo = this.documentos.filter(x => x.idSolDocumento && x.nombreArchivo).length;
				this.disableCombinacionDocs = documentosConArchivo > 0;

				this.$emit('documento-changed', documento);
			},
			getFormulario() {
				/*
				20 ->	Solicitud sin firmar (la 30 no se usa actualmente)
				22 -> Modelo 145 sin firmar
				31 -> Declaración incompleta
				32 -> Modelo 145 incompleto
				*/

				var url = null;

				switch (this.campo.id) {
					case 13:
						url = 'https://umivaleactiva.es/dam/umivale-activa/Plantilla-acreditaci-n-Reducci-n-de-facturaci-n.xlsx';
						break;
					case 20:
						url = 'https://umivaleactiva.es/dam/web-corporativa/Formularios/Prestaciones/Cese-de-Actividad-de-Trabajador-Aut-nomo/200330-Solicitud-extraordinaria-CATA.pdf';
						break;
					case 22:
					case 32:
						url = 'https://www.agenciatributaria.es/static_files/Sede/Procedimiento_ayuda/G603/mod145_es_es.pdf';
						break;
				}

				return window.open(url);
			},
			getDocumentoIncompleto() {
				api.getDocumentoIncompleto(this.campo.idSolicitud, this.campo.idSolTipoDocumento,
					res => {
					},
					error => {
						this.$emit('alert-event', { text: 'Error al obtener el documento incompleto', color: 'red' });
					}
				);
			},
			// Se comenta porque no es necesario para prestaciones PETECATA y POECATA
			// checkIdCombinaciones(combinacionDocs) {
			// 	return combinacionDocs.find(item => item.idCombinacion === 102 || item.idCombinacion === 103);
			// }
		}
	},
	mounted() {
		if (this.campo.combinacionDocs.length == 1) {
			this.idCombinacion = this.campo.combinacionDocs[0].id;
		} else if (this.campo.idCombinacionDocSeleccionada) {
			this.idCombinacion = this.campo.idCombinacionDocSeleccionada;
		}

		if (this.idCombinacion) {
			this.getCombinacionDocumentos(this.campo.combinacionDocs);
		}
	}
}
</script>